"use strict";
/*
 * Integration App React package
 * {@link https://www.npmjs.com/package/@integration-app/react}
 * v2.13.0
 */
'use client';

import { useElements } from '../useElements.mjs';

function useActionInstances(query) {
  const { ...rest } = useElements("action-instances", query);
  return {
    actionInstances: rest.items,
    ...rest
  };
}

export { useActionInstances };
